import React from 'react';
import { Workflow, Search, Radio, Repeat } from 'lucide-react';
import FeatureCard from './FeatureCard';

const Features = () => {
  const features = [
    {
      icon: <Workflow className="h-10 w-10 text-teal-400" />,
      title: 'Workflows',
      description: 'Automate repetitive tasks with intelligent workflows. Create custom automation sequences that work across applications.',
      color: 'from-teal-500 to-cyan-500',
      delay: '0'
    },
    {
      icon: <Search className="h-10 w-10 text-cyan-400" />,
      title: 'Research',
      description: 'Gather, analyze, and summarize information from multiple sources. Get comprehensive insights without the information overload.',
      color: 'from-cyan-500 to-blue-500',
      delay: '150'
    },
    {
      icon: <Radio className="h-10 w-10 text-blue-400" />,
      title: 'Social Listening',
      description: 'Monitor mentions, trends, and sentiments across social media platforms. Stay informed about what matters to your audience.',
      color: 'from-blue-500 to-indigo-500',
      delay: '300'
    },
    {
      icon: <Repeat className="h-10 w-10 text-indigo-400" />,
      title: 'Repeat Jobs',
      description: 'Schedule and automate recurring tasks with precision. Set it up once and let Siva handle the rest for you.',
      color: 'from-indigo-500 to-purple-500',
      delay: '450'
    }
  ];

  return (
    <section id="features" className="py-20 bg-slate-900/50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">How Siva Helps You</h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Siva is designed to make your digital life easier by handling a variety of tasks
            across your computer with intelligence and precision.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              color={feature.color}
              delay={feature.delay}
            />
          ))}
        </div>
        
        <div className="mt-20 bg-slate-800 rounded-2xl p-6 md:p-10 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-1/2 h-full opacity-10">
            <div className="w-full h-full bg-gradient-to-bl from-teal-400 to-transparent transform rotate-45"></div>
          </div>
          
          <div className="relative z-10 max-w-3xl">
            <h3 className="text-2xl md:text-3xl font-bold mb-6">Intelligent, Adaptive, and Always Learning</h3>
            <p className="text-lg text-slate-300 mb-8">
              Siva leverages advanced AI to understand your preferences and adapt to your working style.
              The more you use Siva, the better it gets at anticipating your needs and providing relevant assistance.
            </p>
            
            <ul className="space-y-4 text-slate-300">
              {[
                'Learns from your interactions to improve suggestions',
                'Adapts to your schedule and priorities',
                'Connects with your favorite apps and services',
                'Provides personalized recommendations based on your usage patterns'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-gradient-to-r from-teal-400 to-cyan-500 flex-shrink-0 mt-1"></div>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;